import classNames from "classnames"
import React, { useState, useRef, useCallback } from "react"

import DashboardOptions from "./DashboardOptions"

import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@components/elements/V2/Popover"
import Typography from "@components/elements/V2/Typography"
import { Color } from "@constants/V2/color"

type Props = {
  mode?: "light" | "dark"
  scrolled?: boolean
  isMenuActive?: boolean
}

const AuthenticatedMenu = ({ mode, scrolled, isMenuActive }: Props) => {
  const [open, setOpen] = useState(false)
  const timeoutRef = useRef<NodeJS.Timeout | null>(null)

  const handleMouseEnter = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }
    setOpen(true)
  }, [])

  const handleMouseLeave = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }
    timeoutRef.current = setTimeout(() => {
      setOpen(false)
    }, 200)
  }, [])

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onClick={(e) => {
          e.preventDefault()
        }}
      >
        <Typography
          text="My Dashboard"
          size="body-md"
          font="grotesk"
          weight="medium"
          color={Color.Black}
          className={classNames(
            "mt-1",
            {
              "text-black lg:text-white":
                mode === "dark" && !scrolled && !isMenuActive,
            },
            {
              "text-black": (mode === "light" && scrolled) || isMenuActive,
            }
          )}
        />
      </PopoverTrigger>

      <PopoverContent
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        className="min-w-[314px] gap-[20px] rounded-10 border-none bg-white px-[30px] py-24"
        align="end"
      >
        <DashboardOptions />
      </PopoverContent>
    </Popover>
  )
}

export default AuthenticatedMenu
